import { Platform } from "react-native";
import Constants from "../../utilities/Constants";
import Storage from "../../utilities/storage/StorageFunctions";
import Config from "react-native-config";
import { getAccessToken } from "../exzeoID";

export interface HeaderConfig {
  isForPDF?: boolean;
  isUserAuthRequired?: boolean;
  isAppAccessTokenRequired?: boolean;
  isSignalAbortAllowed?: boolean;
  scope?: string;
}

export const generateHeaders = async (config: HeaderConfig = {}) => {
  const {
    isForPDF = false,
    isAppAccessTokenRequired = false,
    scope = null,
  } = config;

  try {
    const token = await Storage.getData(
      Constants.LocalStoreConstant.ACCESS_TOKEN,
    );
    const source =
      Platform.OS === "web"
        ? process.env.REACT_APP_POLICY_CARRIER
        : Config.REACT_APP_POLICY_CARRIER;

    const baseHeaders = {
      "Content-Type": "application/json",
      "nexus-policy-source": source,
      Authorization: token,
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
      // "ngrok-skip-browser-warning": "true",
    };

    if (isForPDF) {
      return { ...baseHeaders, Accept: "application/pdf" };
    }

    if (isAppAccessTokenRequired && scope) {
      const accessToken = await getAccessToken(scope);
      return { ...baseHeaders, Authorization: `Bearer ${accessToken}` };
    }

    return baseHeaders;
  } catch (error) {
    console.error("Error generating headers:", error);
    throw error;
  }
};
